import * as types from './mutation-types'

export const changeEnv = ({ commit }, payload) => {
    commit(types.CHANGE_ENVIRONMENT, payload)
}

export const setOrUpdateNonces = ({ commit }, payload) => {
    commit(types.SET_OR_UPDATE_NONCES, payload)
}

export const isAuthenticated = ({ commit }) => {
    commit(types.IS_AUTHENTICATED)
}

export const authenticate = ({ commit }, payload) => {
    commit(types.AUTHENTICATE, payload)
}

export const invalidate = ({ commit }) => {
    commit(types.INVALIDATE)
}

export const setUserInfo = ({ commit }, payload) => {
    commit(types.SET_USER_INFO, payload)
}

export const setMaintenanceSettings = ({ commit }, payload) => {
    commit(types.MAINTENANCE_SETTINGS, payload)
}

export default {
    isAuthenticated,
    authenticate,
    invalidate,
    setUserInfo,
    setOrUpdateNonces,
    changeEnv,
    setMaintenanceSettings
}
